<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">能源行业解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          太阳能光伏发电项目随中国政府持续出台的支持光伏产业发展的政策不断增多。国家能源局发布消息称，截至2015年底，中国光伏发电累计装机容量4318万千瓦，成为全球光伏发电装机容量最大的国家。随着大型光伏电站及分布式光伏系统的建设和投运，业主及电网公司对设备的实时监控提出了更高的要求。IEEE1547规定，功率超过250kW的分布式电源必须安装监测系统，以监视DR的接入状态、有功、无功输出和连接点的电压。监控技术是保证光伏电站正常运营的关键技术之一，由于监控系统占项目初始投资比重较小，人们对这一部分市场长期缺乏重视。
        </div>
        <div class="title-sub">光伏监控系统需实现的功能有</div>
        <div class="text">
          1）光伏电站内包括升压站及发电阵列各类电气设备、汇流箱、逆变器、电池板、蓄电池组及其控制器、环境温度等底层设备实时数据及状态的采集；<br>
          2）底层设备故障报警；<br>
          3）重要数据的历史存储；<br>
          4）远方及本地对电站设备的操做与控制。即集遥测、遥控、遥信、遥调功能为一体，且需具备高可靠性，全年不间断工作。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          国电橡诺光伏监控系统软件将电网运行监控系统成功移植到光伏发电运行监控'并实现现场视频监控、发电运行监控与生产运行管理融为一体。<br>
          光伏发电监控系统可对太阳能光伏电站内升压站以及电池阵列、汇流箱、逆变器、交直流配电柜、太阳跟踪控制系统等设备进行实时监控和控制，通过各种样式的图表及数据快速掌握电站的运行情况，其友好的用户界面、强大的分析功能、完善的故障报警确保了太阳能光伏发电系统的安全可靠和稳定运行。
        </div>
        <div class="title-sub">总体建设框架</div>
        <div class="text">
          <div class="img"><img src="@/assets/img/solution/5/1.png"></div>
        </div>
        <div class="title-sub">基本功能</div>
        <div class="text">
          实时监测升压站各类电气设备的电压、电流、功率及其运行状况<br>
          实时监测太阳能电池板的电压、电流及其运行状况<br>
          防雷器状态、断路器状态采集与显示<br>
          实时监控逆变器工作状态'监测其故障信息<br>
          系统详细运行参数显示<br>
          故障记录及报警<br>
          具有电量累计、系统分析、历史记录功能<br>
          简单易用的参数设置功能<br>
          系统输出电流、电压'瞬时发电功率、累计发电量<br>
          CO2 SO2减排量,标准煤节省量
        </div>
        <div class="title-sub">画面显示</div>
        <div class="text">
          系统运行主画面<br>
          监控系统提供功能选择画面'并对光伏阵列现场环境进行实时监测与显示'如室外温度值、湿度百分比、光照度及阵列表面温度值等<br>
          汇流监测系统画面<br>
          监控系统可分区域实时监测各光伏阵列的充电电压及电流、蓄电池电压及温度(含蓄电池的情况)等信息'并对故障点进行异常显示与报警提示。<br>
          逆变器监测画面<br>
          监控系统可绘制显示逆变器电压一时间曲线、功率一时间曲线等'直流侧输入电流实时曲线、交流侧逆变输出电流曲线'采集与显示日发电量等电参量。<br>
          事件记录监测画面<br>
          监控系统可针对光伏发电现场的各种事件进行记录'如:通讯采集异常、开关变位、操作记录等事件记录支持按类型查询'并可对越限报警进行更改设置;<br>
          曲线、报表分析画面<br>
          监控系统对光伏发电的发电量可形成月棒图及年度捧图显示，并折算成二氧化碳、二氧化硫减排量值;并可查看太阳辐射强度趋势曲线、风速变化趋势曲线
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          及时有效获得光伏电站的实时信息，从太阳能电池板、汇流箱、逆变器直至并网升压110kV变电站内一次二次设备的实时信息，报警故障信息等。<br>
          有效的监控系统提高工作效率，减少光伏电站人员配置及工作量。<br>
          实时获得太阳能发电量并计算节能减排效果。<br>
          给用户带来了实际的效益，通过光伏监控，用户因为电网调度导致的并网罚款减少。
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        // width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>